import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (!_ctx.loggedIn)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true)
}